import { useEffect, useState } from "react";
import axios from "axios";

const CommentList = ({ placeName, refreshTrigger }) => {
  const [comments, setComments] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;

  const fetchComments = async () => {
    try {
      const res = await axios.get(`${API_URL}/get_comments`, {
        params: { place_name: placeName },
      });
      setComments(res.data.comments);
    } catch (err) {
      console.error("Yorumlar alınamadı:", err);
    }
  };

  useEffect(() => {
    fetchComments();
  }, [placeName, refreshTrigger]); // refreshTrigger değişince tekrar çek

  return (
<div className="mt-4">
  <h2 className="text-2xl font-bold text-white mb-4 border-b-2 border-blue-500 pb-2">
    Yorumlar
  </h2>
  {comments.length === 0 ? (
    <div className="bg-gray-800 p-6 rounded-lg text-center text-gray-400 border border-gray-700">
      <p className="italic">Henüz yorum yapılmamış. İlk yorumu sen yap!</p>
    </div>
  ) : (
    <ul className="space-y-4">
      {comments.map((comment, index) => (
        <li
          key={index}
          className="relative bg-gray-800 p-6 rounded-lg shadow-md border border-gray-700 transition-all duration-200 hover:shadow-lg"
        >
          <div className="flex justify-between items-center mb-2">
            <strong className="text-blue-400 font-semibold">{comment.username}</strong>
            <span className="text-xs text-gray-500">
              {new Date(comment.created_at).toLocaleString()}
            </span>
          </div>
          <p className="text-gray-300 leading-relaxed">
            {comment.comment_text}
          </p>
        </li>
      ))}
    </ul>
  )}
</div>
  );
};

export default CommentList;
